import React from 'react';
import style from './index.module.css';
import { getImage, getIcon } from '../../utils/utils';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

const DetailsCard = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
		<motion.div 
			whileHover={{ scale: 1.02 }}
			className={style.card}
			style={{
				backgroundColor: isDark ? 'rgba(255, 255, 255, 0.03)' : theme.palette.background.paper,
				color: theme.palette.text.primary,
				boxShadow: isDark ? '0 15px 40px rgba(0,0,0,0.4)' : '0 15px 40px rgba(0,0,0,0.08)',
			}}
		>
			<div className={style.cardBody}>
				{props.icon && (
					<motion.div 
						initial={{ rotate: -10 }}
						whileHover={{ rotate: 0, scale: 1.1 }}
						className={style.iconStyle}
						style={{ backgroundColor: theme.palette.primary.main }}
					>
						{getIcon(props.icon)}
					</motion.div>
				)}

				{props.image && (
					<motion.div 
						className={style.imageContainer}
						whileHover={{ scale: 1.05 }}
					>
						<img
							className={style.middleImageStyle}
							src={getImage(props.image)}
							alt={props.header}
						/>
					</motion.div>
				)}
				<div className={style.header}>
					<h2 className={style.cardHeadingText} style={{ color: theme.palette.primary.main }}>
						{props.header}
					</h2>
					<p className={style.cardContentText} style={{ color: theme.palette.text.secondary }}>
						{props.content}
					</p>
				</div>
			</div>
		</motion.div>
	);
};

export default DetailsCard;
